
<div class="container" style="padding-top: 5%;">
    <div class="card" style=" width: 100%; ">
        <div class="wrapper">
            <div class="card ">
                <div class="card-header" style="padding-top: 2%;">
                    <h2>Report Request</h2>
                </div>
                <div class="card-body">
                    <form [formGroup]="ReportRequestForm" (ngSubmit)="submit()">
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label for="inputName">Name</label>
                                <input placeholder="Name" formControlName="name" type="text" class="form-control">
                                <div class="error" *ngIf="f.name.errors && (f.name.touched||f.name.dirty)">
                                    <div *ngIf="f.name.errors.required">
                                        Name is required.
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-md-6">
                                <label for="inputSSN">SSN</label>
                                <input placeholder="SSN"  mask='000-00-0000' placeholder='000-00-0000'  formControlName="SSN" type="text" class="form-control">
                                <div class="error" *ngIf="f.SSN.errors && (f.SSN.touched||f.SSN.dirty)">
                                    <div *ngIf="f.SSN.errors.required">
                                        SSN is required.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label for="inputEmail">Email</label>
                                <input placeholder="Email" formControlName="email" type="text" class="form-control">

                                <div class="error" *ngIf="f.email.errors && (f.email.touched||f.email.dirty)">
                                    <div *ngIf="f.email.errors.required">
                                        Email is required.
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-md-6">
                                <label for="inputDOB">DOB</label>
                                <input type="date" formControlName="DOB" class="form-control">
                                <div class="error" *ngIf="f.DOB.errors && (f.DOB.touched||f.DOB.dirty)">
                                    <div *ngIf="f.DOB.errors.required">
                                        DOB is required.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label for="inputAddress">Address</label>

                                <input ngx-google-places-autocomplete class="form-control" [options]="{ types: [], componentRestrictions: { country: 'UA' } }" #placesRef="ngx-places" (onAddressChange)="handleAddressChange($event)"/>

                                <div class="error" *ngIf="f.streetAddress.errors && (f.streetAddress.touched||f.streetAddress.dirty)">
                                    <div *ngIf="f.streetAddress.errors.required">
                                        Address is required.
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-md-6">
                                <label for="inputCity">City</label>
                                <input placeholder="City" formControlName="city" type="text" class="form-control">
                                <div class="error" *ngIf="f.city.errors && (f.city.touched||f.city.dirty)">
                                    <div *ngIf="f.city.errors.required">
                                        City is required.
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-md-6">
                                <label for="inputState">State</label>
                                <input placeholder="State" formControlName="state" type="text" class="form-control">
                                <div class="error" *ngIf="f.state.errors && (f.state.touched||f.state.dirty)">
                                    <div *ngIf="f.state.errors.required">
                                        State is required.
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-md-6">
                                <label for="inputZipcode">Zipcode</label>
                                <input placeholder="Zipcode" formControlName="zipcode" pattern="[0-9]*" 
                                inputmode="numeric"
                                type="text"class="form-control">
                                <div class="error" *ngIf="f.zipcode.errors && (f.zipcode.touched||f.zipcode.dirty)">
                                    <div *ngIf="f.zipcode.errors.required">
                                        Zipcode is required.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-12">
                                <label for="inputGroupFile01"> Upload Documents</label>
                                <div class="custom-file">
                                    <input type="file" class="custom-file-input" formControlName="document"
                                        id="inputGroupFile01" (change)="onFileChange($event)"
                                        accept="image/apng, image/ jpeg, image/jpg, .pdf">
                                    <label class="custom-file-label" for="inputGroupFile01">Choose file</label>
                                    <button class="mr-1 mb-1 btn btn-outline-primary right" type="button"
                                    (click)="onDocumentUpload()">Upload File</button>
                                    <span class="text-danger"
                                        *ngIf="f.document.errors && f.document.hasError('required') && (f.document.dirty || f.document.touched)">
                                        File is required
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="inputinformation">Any other information</label>
                            <textarea class="form-control" formControlName="LCIJInput"
                                placeholder="information..."></textarea>
                        </div>
                        <button type="submit" class="btn btn-primary" style="float: right;">Submit</button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>